import { useCallback, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useSSEStream } from '../../hooks/useSSEStream';
import { INTERACTIVE_SERVICE_BASE_URL } from '../constants';
import { SSE_COMPLETION_EVENTS } from '../hooks/useChat';

const StreamMonitor = ({ sessionKey, runId, onMessage, onError, resumeSignal = 0 }) => {
    const handleMessage = useCallback(
        message => onMessage(sessionKey, message),
        [sessionKey, onMessage]
    );

    const { error, resume } = useSSEStream(INTERACTIVE_SERVICE_BASE_URL, runId, handleMessage, SSE_COMPLETION_EVENTS);

    useEffect(() => {
        if (error) onError(sessionKey, error);
    }, [error, sessionKey, onError]);

    // The server closes the stream while a run waits on a confirmation, so answering one has
    // to reopen it. The signal is a counter rather than a flag: consecutive confirmations in
    // one run must each reconnect.
    const lastResumeSignalRef = useRef(resumeSignal);
    useEffect(() => {
        if (resumeSignal === lastResumeSignalRef.current) return;
        lastResumeSignalRef.current = resumeSignal;
        resume();
    }, [resumeSignal, resume]);

    return null;
};

StreamMonitor.propTypes = {
    sessionKey: PropTypes.string.isRequired,
    runId: PropTypes.string.isRequired,
    onMessage: PropTypes.func.isRequired,
    onError: PropTypes.func.isRequired,
    resumeSignal: PropTypes.number,
};

export default StreamMonitor;
